import { render, staticRenderFns } from "./DragDropDashboard.vue?vue&type=template&id=3cf4ab14&scoped=true"
import script from "./DragDropDashboard.vue?vue&type=script&lang=js"
export * from "./DragDropDashboard.vue?vue&type=script&lang=js"
import style0 from "./DragDropDashboard.vue?vue&type=style&index=0&id=3cf4ab14&prod&scoped=true&lang=css"
import style1 from "./DragDropDashboard.vue?vue&type=style&index=1&id=3cf4ab14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf4ab14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VDialog,VIcon,VProgressCircular,VRow,VSpacer})
